export const CHART_TYPES = {
  DOUGHNUT: 'DOUGHNUT',
  HALF_DOUGHNUT: 'HALF_DOUGHNUT',
  MISSING_PART_DOUGHNUT: 'MISSING_PART_DOUGHNUT',
};
